import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { hasPermissionToEditUserForm } from '../user.helpers';
import { LoggedInUser } from '../../../state/helperServices/auth/auth.interfaces';

interface UserCardActionProps {
  user: any;
  onEdit?: any;
  loginUser?: LoggedInUser;
  isNetworkConnected?: boolean;
}

export const UserCardAction = ({
  user,
  onEdit,
  loginUser,
  isNetworkConnected,
}: UserCardActionProps) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menuOptions = [
    {
      title: `${t('EDIT')}`,
      action: (_user: any) => {
        onEdit(_user?.id);
        handleClose();
      },
    },
  ];

  return (
    <>
      {isNetworkConnected &&
        menuOptions &&
        hasPermissionToEditUserForm(loginUser) && (
          <>
            <IconButton
              data-testid={`userActions-${user?.firstName}-${user?.lastName}`}
              id="more-button"
              aria-label={t('accessibility.SETTINGS')}
              sx={{ m: 1 }}
              onClick={handleClick}
            >
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'more-button',
              }}
            >
              {menuOptions.map((mo) => {
                return (
                  <MenuItem
                    key={mo.title}
                    onClick={() => mo.action(user)}
                    data-testid={`user-${user?.firstName}-${user?.lastName}`}
                  >
                    {mo.title}
                  </MenuItem>
                );
              })}
            </Menu>
          </>
        )}
    </>
  );
};
